import { generateBreakPoints } from "../../../../helpers/generateBreakPoints";
import { ColorRangeI } from "../../../../models/Pages";

export const generateColorRanges = (
  variations: string[],
  values: number[],
  setColorRanges: React.Dispatch<React.SetStateAction<ColorRangeI[]>>,
  ranges?: number[]
) => {
  if (!variations?.length || !values?.length) {
    setColorRanges([]);
    return;
  }
  const colorRanges = [];
  const sortedValues = [...new Set(values)].sort((a, b) => a - b);

  const steps = ranges?.some((r) => r > 0)
    ? ranges
    : generateBreakPoints(sortedValues);

  for (let i = 0; i < steps?.length; i++) {
    const end = i === steps?.length - 1 ? steps[i] * 3 : steps[i + 1];
    const colorRange = {
      color: variations[i],
      start: parseInt(steps[i]?.toString()),
      end:
        i === steps.length - 1
          ? sortedValues.at(-1)!
          : parseInt(end?.toString()),
    };
    colorRanges.push(colorRange);
  }
  setColorRanges(colorRanges);
};
